module.exports = __webpack_public_path__ + "static/media/reject-invitation.0432468f.svg";